import React, { useState } from 'react';
import { Button, Form } from 'antd';
import { FieldEmail } from 'shared/components/fields/fieldEmail/FieldEmail';
import { FieldPassword } from 'shared/components/fields/fieldPassword/FieldPassword';
import { apiUser } from 'utilities/http/api/apiUser';
import userStorage from 'utilities/user/userStorage';
import { Store } from 'antd/lib/form/interface';
import { notify } from 'utilities/notifications/notify';
import { useHistory } from 'react-router-dom';
import { Credentials } from 'types';
import {
  LoginForm,
  LoginFormColumn,
  LoginGrid,
  LoginImg,
  LoginImgWrap,
  LoginLogo,
} from './Login.styles';
import { ReactComponent as PuppySpotKennel } from './ps-kennel.svg';
import { log } from 'utilities/log/log';

export function Login() {
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const history = useHistory();

  function handleError(error?: string) {
    setSubmitLoading(false);
    notify.error(error || 'Please use valid credentials');
    userStorage.removeUserAndToken();
  }

  const onSubmit = async (info: Credentials | Store) => {
    setSubmitLoading(true);

    const { password, email } = info;
    const body: Credentials = { email, password };
    try {
      const authResponse = await apiUser.authLogin(body);
      if (!authResponse.isOk) {
        handleError();
        return;
      }

      userStorage.setToken(authResponse.json.token);

      const userResponse = await apiUser.getUser();
      if (!userResponse.isOk) {
        handleError('Not a valid user');
        return;
      }

      userStorage.setUser(userResponse.json.user);
      setSubmitLoading(false);
      history.push('/dashboard');
    } catch (e) {
      log.debug('login > onSubmit', e);
      handleError();
    }
  };

  return (
    <LoginGrid>
      <LoginImgWrap>
        <LoginImg src={`${process.env.PUBLIC_URL}/puppy.png`} />
      </LoginImgWrap>
      <LoginFormColumn>
        <LoginLogo>
          <PuppySpotKennel />
        </LoginLogo>
        <LoginForm size="large" onFinish={onSubmit}>
          <h2>Welcome Back!</h2>
          <FieldEmail />
          <FieldPassword placeholder="Type your password" minimumPasswordLength={3} />
          <Form.Item style={{ textAlign: 'right' }}>
            <Button type="primary" htmlType="submit" loading={submitLoading}>
              Log In
            </Button>
          </Form.Item>
        </LoginForm>
      </LoginFormColumn>
    </LoginGrid>
  );
}
